var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"show-password-modal",attrs:{"id":"show-password-modal","no-close-on-backdrop":"","ok-only":"","no-stacking":""},on:{"show":_vm.getPassword,"hide":_vm.forgetPassword}},[_c('template',{slot:"modal-title"},[_vm._v(" "+_vm._s(_vm.$t('showPassword')))]),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.password))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }